{
  "CUSTOM_ROLE": {
    "HEADER": "Vlastní role",
    "LEARN_MORE": "Více o vlastních rolích",
    "DESCRIPTION": "Vlastní role jsou role, které jsou vytvořeny vlastníkem účtu nebo administrátorem. Tyto role mohou být přiřazeny agentům k definování jejich přístupu a oprávnění v rámci účtu. Vlastní role lze vytvořit se specifickými oprávněními a úrovněmi přístupu podle požadavků organizace.",
    "HEADER_BTN_TXT": "Přidat vlastní roli",
    "LOADING": "Načítání vlastních rolí...",
    "SEARCH_404": "Neexistují žádné položky odpovídající tomuto dotazu.",
    "PAYWALL": {
      "TITLE": "Upgradujte pro vytvoření vlastních rolí",
      "AVAILABLE_ON": "Funkce vlastních rolí je dostupná pouze v plánech Business a Enterprise.",
      "UPGRADE_PROMPT": "Upgradujte svůj plán pro přístup k pokročilým funkcím jako je správa týmů, automatizace, vlastní atributy a další.",
      "UPGRADE_NOW": "Upgradovat nyní",
      "CANCEL_ANYTIME": "Svůj plán můžete kdykoli změnit nebo zrušit"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Funkce vlastních rolí je dostupná pouze v placených plánech.",
      "UPGRADE_PROMPT": "Upgradujte na placený plán pro přístup k pokročilým funkcím jako jsou auditní záznamy, kapacita agentů a další.",
      "ASK_ADMIN": "Pro upgrade se obraťte na svého administrátora."
    },
    "LIST": {
      "404": "V tomto účtu nejsou k dispozici žádné vlastní role.",
      "TITLE": "Správa vlastních rolí",
      "DESC": "Vlastní role jsou role, které jsou vytvořeny vlastníkem účtu nebo administrátorem. Tyto role mohou být přiřazeny agentům k definování jejich přístupu a oprávnění v rámci účtu. Vlastní role lze vytvořit se specifickými oprávněními a úrovněmi přístupu podle požadavků organizace.",
      "TABLE_HEADER": {
        "NAME": "Název",
        "DESCRIPTION": "Popis",
        "PERMISSIONS": "Oprávnění",
        "USAGE_COUNT": "Používá",
        "ACTIONS": "Akce"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "Správa všech konverzací",
      "CONVERSATION_UNASSIGNED_MANAGE": "Správa nepřiřazených konverzací a těch, které jsou jim přiřazeny",
      "CONVERSATION_PARTICIPATING_MANAGE": "Správa participujících konverzací a těch, které jsou jim přiřazeny",
      "CONTACT_MANAGE": "Správa kontaktů",
      "ACCESS_ALL_REPORTS": "Neomezené prohlížení reportů",
      "KNOWLEDGE_BASE_MANAGE": "Správa znalostní báze",
      "DATA_ASSISTANT_MANAGE": "Správa datového asistenta",
      "CALL_RECORDING_ACCESS": "Přístup ke všem nahrávkám hovorů"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Název",
        "PLACEHOLDER": "Zadejte název.",
        "ERROR": "Název je povinný."
      },
      "DESCRIPTION": {
        "LABEL": "Popis",
        "PLACEHOLDER": "Zadejte popis.",
        "ERROR": "Popis je povinný."
      },
      "PERMISSIONS": {
        "LABEL": "Oprávnění",
        "ERROR": "Oprávnění jsou povinná."
      },
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "API": {
        "ERROR_MESSAGE": "Nelze se připojit k Woot serveru, opakujte akci později"
      }
    },
    "ADD": {
      "TITLE": "Přidat vlastní roli",
      "DESC": "Vlastní role vám umožňují vytvářet role se specifickými oprávněními a úrovněmi přístupu podle požadavků organizace.",
      "SUBMIT": "Odeslat",
      "API": {
        "SUCCESS_MESSAGE": "Vlastní role byla úspěšně přidána."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Upravit",
      "TITLE": "Upravit vlastní roli",
      "DESC": "Vlastní role vám umožňují vytvářet role se specifickými oprávněními a úrovněmi přístupu podle požadavků organizace.",
      "SUBMIT": "Aktualizovat",
      "API": {
        "SUCCESS_MESSAGE": "Vlastní role byla úspěšně aktualizována."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazat",
      "API": {
        "SUCCESS_MESSAGE": "Vlastní role byla úspěšně smazána.",
        "ERROR_MESSAGE": "Nelze se připojit k Woot serveru, opakujte akci později"
      },
      "CONFIRM": {
        "TITLE": "Potvrdit smazání",
        "MESSAGE": "Opravdu chcete odstranit ",
        "YES": "Ano, smazat ",
        "NO": "Ne, zachovat "
      }
    }
  }
}
